"use client";

import { create } from "zustand";

export interface VeliaSettings {
  nickname?: string;
  job?: string;
  veliaPrompt?: string;
}

export interface UserProfile {
  id: string;
  email: string;
  tier: string;
  team_id: string | null;
  role: string | null;
  velia: VeliaSettings | null;
}

interface UserStoreState {
  profile: UserProfile | null;
  loading: boolean;
  error: string | null;
  setProfile: (profile: UserProfile | null) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  clear: () => void;
}

export const useUserStore = create<UserStoreState>((set) => ({
  profile: null,
  loading: false,
  error: null,
  setProfile: (profile) => set({ profile }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  clear: () => set({ profile: null, loading: false, error: null }),
}));

